import { render, staticRenderFns } from "./Categories-Create.vue?vue&type=template&id=22e4bcc5&scoped=true&"
import script from "./Categories-Create.vue?vue&type=script&lang=js&"
export * from "./Categories-Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4bcc5",
  null
  
)

export default component.exports